import React, { useState, useEffect } from "react"
import { Spinner } from "../shared/Spinner"
import { RequestError } from "../shared/RequestError"
import { useRelatedPosts } from "../../hooks/useRelatedPosts"
import { MiniLinkPreview } from "../posts/MiniLinkPreview"

const RelatedPosts = ({
  postId,
  headerText = "Related Posts",
  className = "my-4",
  mode = "full",
  nadaUrl,
}) => {
  const PER_PAGE = 3
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(PER_PAGE)
  const [currentCount, setCurrentCount] = useState(0)
  const [totalCount, setTotalCount] = useState(0)

  const [relatedPosts, setRelatedPosts] = useState([])

  const { isLoading, isError, isFetching, data, error } = useRelatedPosts(
    postId,
    page,
    perPage,
  )

  useEffect(() => {
    if (!isLoading && !isError && !isFetching && data) {
      const posts = data.posts || []
      if (page === 1) {
        setRelatedPosts(posts)
        setCurrentCount(posts.length)
      } else {
        setRelatedPosts((prevPosts) => [...posts, ...prevPosts])
        setCurrentCount((prevCount) => posts.length + prevCount)
      }
      setTotalCount(data.total_count || 0)
    }
  }, [isFetching, data, page, isLoading, isError])

  const showMore = (e) => {
    if (perPage !== PER_PAGE) {
      setPerPage(PER_PAGE)
    } else {
      setPage((curPage) => curPage + 1)
    }
  }

  if (mode === "hide") return null
  if (mode === "hint") {
    return (
      <a href={nadaUrl ? `${nadaUrl}#related` : "#related"} className="text-xs text-gray-500 mt-2 block">
        Related posts →
      </a>
    )
  }

  return isFetching ? (
    <Spinner />
  ) : error ? (
    <RequestError error={error} />
  ) : data ? (
    currentCount > 0 ? (
      <div className={className}>
        <h4 className="uppercase font-bold text-gray-700 text-xs">
          {headerText}&nbsp;
          <>
            <span className="font-normal">
              ({currentCount}/{totalCount})
            </span>
            {currentCount < totalCount ? (
              <span>
                <button
                  className="pl-2 text-blue-500 focus:outline-none"
                  onClick={showMore}
                >
                  show more
                </button>
              </span>
            ) : null}
          </>
        </h4>
        <ul>
          {relatedPosts.length > 0
            ? relatedPosts.map((relatedPost) => (
                <div key={`related-post-${relatedPost.id}`} className="mb-3">
                  <MiniLinkPreview post={relatedPost} />
                </div>
              ))
            : null}
        </ul>
      </div>
    ) : null
  ) : null
}

export default RelatedPosts
